<div class="columns-wrapper">
  <ng-content select="itl-desktop-column"></ng-content>
</div>
